import { cn } from "@/lib/utils";

// Primitivas de layout de formulário usadas pelas telas com grid de seções
// em routes/index.tsx (Cadastrar/Editar veículo — VehicleFormPanel — e as
// demais telas de Configurações/Permissões mock). Ficam num módulo próprio
// só por organização, não por causa de import circular (routes/index.tsx é
// hoje o único dono do form de veículo, cadastro e edição).

export function Section({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
}) {
  return (
    <section className="mb-8">
      <div className="mb-4">
        <h3 className="text-sm font-semibold tracking-tight">{title}</h3>
        {description && <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>}
      </div>
      <div className="rounded-xl border border-border bg-background/40 p-5">{children}</div>
    </section>
  );
}

export function Field({
  label,
  children,
  hint,
  span,
}: {
  label: string;
  children: React.ReactNode;
  hint?: string;
  span?: 1 | 2 | 3;
}) {
  return (
    <div className={cn("space-y-1.5", span === 2 && "md:col-span-2", span === 3 && "md:col-span-3")}>
      <label className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
        {label}
      </label>
      {children}
      {hint && <p className="text-[11px] text-muted-foreground">{hint}</p>}
    </div>
  );
}

export function TxtInput(props: React.ComponentProps<"input">) {
  return (
    <input
      {...props}
      className={cn(
        "flex h-9 w-full rounded-md border border-border bg-background px-3 text-sm outline-none transition-colors placeholder:text-muted-foreground focus:border-foreground/40",
        props.className,
      )}
    />
  );
}

export function InfoRow({ label, value, mono }: { label: string; value: string; mono?: boolean }) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-border/60 pb-2 last:border-0 last:pb-0">
      <span className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</span>
      <span className={cn("text-right text-sm", mono && "font-mono")}>{value}</span>
    </div>
  );
}
